import React from "react";
import { useState, useEffect }  from "react";
import { Link } from "react-router-dom";
import Tender from "./Tender";

import {getTranslations} from './Translations'


export default function TenderListOfTiles(){
    let translations;
    const [tenders, setTenders] = useState([]);
    translations = getTranslations(window.HRMRecruitmentComponentConfiguration?.language);

    useEffect(() => {
        
        const apiUrl = window.HRMRecruitmentComponentConfiguration?.apiUrl;
        const language = window.HRMRecruitmentComponentConfiguration?.language;
        const publicationPlaceCode = window.HRMRecruitmentComponentConfiguration?.publicationPlaceCode;
        const renderingMode = window.HRMRecruitmentComponentConfiguration.renderingMode;

        fetch((apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl) + "/ExternalApi/JobPositionTenderList?language=" +language + (publicationPlaceCode != null ? "&publicationPlaceCode="+publicationPlaceCode: '')+"&renderingMode="+renderingMode, {
            method: "GET"
          })
        //  fetch("list.json")
        .then(res => 
            res.json() 
        )
        .then((result) => {
            // console.log(result);
            if(result.Status == "Error")
            {
                setTenders(null);
                alert(result.Message);
            }
            else
                setTenders(result.Data);
          },(error) => {
               console.log(translations.error);
               console.log(error);
               alert(translations.error+": "+error)
          }
        )
    }, [])

    function downloadBase64File(contentType, base64Data, fileName) {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
   }

   function openPdfInNewTab(pdfStringBase64)
   {
    let pdfWindow = window.open("")
    pdfWindow.document.write(
    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
    encodeURI(pdfStringBase64) + "'></iframe>");
   }

   const handleClick = (pdfStringBase64, fileType, fileName) => {
    if(fileType != null && pdfStringBase64 != "")
    {
        if(fileType.includes("application/pdf"))
            openPdfInNewTab(pdfStringBase64);
        else
            downloadBase64File(fileType, pdfStringBase64, fileName)
    }
  }

    function renderTile(tender, columns,i) {
        let link = "#/tender/" + tender.Id + "/" + tender.Name;
return <div id={tender.Id} className="tile-item">
    
    <img className="tile-item-image" src={"data:"+tender.ImageType+";base64,"+tender.ImageContent}></img>

    <div className="tile-item-content">
        <h4 className="tile-item-title">{tender.Name}</h4>
        <hr></hr>
        <div className="tile-item-description" dangerouslySetInnerHTML={{__html: tender.ShortDescription}}/>
        {tender.ValidTo != null ? <div className="tile-item-validto">{columns.find(x=>x.Key=="ValidTo").Label}: {tender.ValidTo}</div> : ""} 
        <div className="tile-item-buttons-div">
            {tender.AttFileContent != null ? <a className="tile-item-button-a" href="javascript:void(0);" onClick={()=>handleClick(tender.AttFileContent, tender.AttFileType, tender.AttFileName)}><button className="tile-item-button">{columns.find(x=>x.Key=="ShowMore").Label}</button></a> : ""}
            <a className="tile-item-button-a" href={link}><button className="tile-item-button">{columns.find(x=>x.Key=="ApplyToTender").Label}</button></a>
        </div>
    </div>
</div>
    }

    if(tenders?.Columns == null)
    {
        return (
            <div>{translations?.noTenders}</div>
        );
    }

    return (
        <>
            <div className ="tiles-container">
                {tenders.Tenders.map((tender, i) => (
                            <>
                                {renderTile(tender, tenders.Columns,i)}
                            </>
                ))}

            </div>
        </>
    )
}
